import React from 'react';
import { Input, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import css from './SurveyStudentSearch.scss';
import StyledButton from "../common/StyledButton";

export default class SurveyStudentSearch extends React.Component {
    constructor() {
        super();
        this.state = { value: "" };
    }

    onSubmit() {
        this.props.searchStudentInSurvey(this.state.value);
    }

    render() {
        return (
            <div className={css['search-box']}>
                <Input type="text"
                       tabIndex="0"
                       icon={<Icon name ="close"
                                   title="Close search filter"
                                   link
                                   onClick={this.props.onCloseSearch}
                                   role="button"
                                   tabIndex="0"
                                   aria-label="Close search filter"/>}
                       placeholder="Filter list by student name"
                       onChange={(e) => this.setState({value: e.target.value.trim()})}
                       onKeyUp={(e) => { if(e.keyCode === 13) this.onSubmit()}}
                />
                <StyledButton type="submit"
                        onClick={this.onSubmit.bind(this)}
                        className={css['confirm-button']}
                        aria-label="Search for students">
                    SEARCH
                </StyledButton>
            </div>
        )
    }
}

SurveyStudentSearch.propTypes = {
    searchStudentInSurvey: PropTypes.func.isRequired,
    onCloseSearch: PropTypes.func.isRequired
}

